import React from 'react'
import {
  Typography,
  IconButton,
  ListItem,
  ListItemText,
  ListItemButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import {
  EmptyState,
  StyledDialog,
  StyledDialogTitle,
  StyledList,
  DialogContentContainer,
  StyledEventNoteIcon,
  StyledArrowBackIcon,
  StyledBackButton,
  BackToRoomText,
} from './DischargedPatientsModal.styles'
import { useDischargedPatientsModalLogic } from './DischargedPatientsModal.logic'
import { TDischargedPatientsModalProps } from './DischargedPatientsModal.types'
import PatientManagementModal from '../PatientManagementModal/PatientManagementModal'

const DischargedPatientsModal: React.FC<TDischargedPatientsModalProps> = ({
  open,
  onClose,
}) => {
  const logic = useDischargedPatientsModalLogic()

  return (
    <>
      <StyledDialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        scroll="paper"
      >
        <StyledDialogTitle>
          <Typography variant="h6" component="div" fontWeight={600}>
            Discharged Patients
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={onClose}
            aria-label="close"
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </StyledDialogTitle>
        <DialogContentContainer>
          {logic.dischargedPatients.length > 0 ? (
            <StyledList>
              {logic.dischargedPatients.map((patient) => (
                <ListItem key={patient._id} disablePadding>
                  <ListItemButton
                    onClick={() => logic.setSelectedPatient(patient)}
                  >
                    <ListItemText
                      primary={`${
                        patient.lastName
                      }, ${patient.firstName[0].toUpperCase()}`}
                      secondary={`MRN: ${patient.idMR} • ${logic.getProvider(
                        patient
                      )}`}
                      primaryTypographyProps={{
                        fontWeight: 500,
                        fontSize: 15,
                      }}
                      secondaryTypographyProps={{
                        fontSize: 13,
                        color: 'text.secondary',
                      }}
                    />
                    {(() => {
                      const room = logic.getRoomName(patient)
                      if (!room) return null
                      return (
                        <StyledBackButton
                          onClick={(event) =>
                            logic.handleBackToRoom(
                              event,
                              logic.scheduledSurgeries.find(
                                (surgery) => surgery.patient._id === patient._id
                              )
                            )
                          }
                        >
                          <StyledArrowBackIcon />

                          <BackToRoomText>Back to {room?.name}</BackToRoomText>
                        </StyledBackButton>
                      )
                    })()}
                  </ListItemButton>
                </ListItem>
              ))}
            </StyledList>
          ) : (
            <EmptyState>
              <StyledEventNoteIcon />
              <Typography variant="h6" fontWeight={500}>
                No Discharged Patients
              </Typography>
              <Typography variant="body2" color="text.secondary">
                There are currently no discharged patients in the system.
              </Typography>
            </EmptyState>
          )}
        </DialogContentContainer>
      </StyledDialog>

      {logic.selectedPatient && (
        <PatientManagementModal
          open={!!logic.selectedPatient}
          onClose={() => logic.setSelectedPatient(null)}
          patient={logic.selectedPatient}
        />
      )}
    </>
  )
}

export default DischargedPatientsModal
